import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Infopayment } from '../../interfaces/detail-order.interface';

@Component({
  selector: 'info-payment',
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: `./info-payment.component.html`,
  styleUrl: './info-payment.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoPaymentComponent  implements OnInit{

  @Input() isLoading: boolean = false;

  @Input() infoPayment: Infopayment = {
    payment: '',        // Método de pago utilizado
    costo_envio: 0,     // Costo del envío
    totalOrden: 0,      // Total de la orden
    baksheesh: 0,        // Propina del repartidor
     baseRate: 0,
    serviceRate:0,
    creditAmount: 0,
    cardAmount: 0,
    cashAmount: 0
  };

  ngOnInit(): void {

 this.totalOrden();
  }

  totalOrden(){
    if(this.infoPayment){
      const total = this.infoPayment.totalOrden + this.infoPayment.costo_envio + this.infoPayment.baksheesh + this.infoPayment.baseRate + this.infoPayment.serviceRate;
      // console.log('total de la orden',total);

      return total;
    }

    return 0;
  }
}
